import { Component, Vue, Prop } from 'vue-property-decorator'
import Loader from '@/components/Loader/index.vue'
import vSelect from 'vue-select'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faClose, faCheck } from '@fortawesome/free-solid-svg-icons'

import api from '@/helpers/fetch'
import Fuse from 'fuse.js'
import tableHelper from '@/helpers/table'

library.add(faClose, faCheck)

@Component({
	components: {
		Loader,
		vSelect,
	},
})
export default class BoardResult extends Vue {
	@Prop() readonly value!: boolean
	// @Prop() readonly disabled!: boolean
	@Prop() readonly tooltip!: string
	@Prop() readonly companyName!: string
	@Prop() readonly subjectName!: string

	localValue = false
	mounted() {
		this.localValue = this.value
	}

	toggleValue() {
		this.localValue = !this.localValue
		this.$emit(
			'onClick',
			this.companyName,
			this.subjectName,
			this.localValue,
		)
	}

	formatCNJ(val) {
		return tableHelper.formatCNJ(val)
	}

	copied = false
	copy(tooltip) {
		const cnj = tooltip.split(': ')[1]
		navigator.clipboard.writeText(cnj)

		this.copied = true

		setTimeout(() => {
			this.copied = false
		}, 2000)
	}
}
